export function formatNumber(number) {
    const [integerPart, decimalPart] = number.toString().split('.');
    
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    return decimalPart ? `${formattedInteger},${decimalPart}` : formattedInteger;
}